import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type DsIconName =
  | 'arrow-left'
  | 'arrow-right'
  | 'check'
  | 'chevron-down'
  | 'clock'
  | 'close'
  | 'download'
  | 'flag'
  | 'info'
  | 'menu'
  | 'search'
  | 'settings'
  | 'warning';

const paths: Record<DsIconName, string> = {
  'arrow-left': 'M19 12H5m7 7-7-7 7-7',
  'arrow-right': 'M5 12h14m-7-7 7 7-7 7',
  check: 'm5 12 4 4L19 6',
  'chevron-down': 'm6 9 6 6 6-6',
  clock: 'M12 8v4l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  close: 'M6 6l12 12M18 6 6 18',
  download: 'M12 3v12m-5-5 5 5 5-5M5 21h14',
  flag: 'M5 21V4m0 1h11l-2 4 2 4H5',
  info: 'M12 11v6m0-10v.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
  menu: 'M4 7h16M4 12h16M4 17h16',
  search: 'm21 21-4.35-4.35m2.35-5.65a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z',
  settings:
    'M12 15.5A3.5 3.5 0 1 0 12 8a3.5 3.5 0 0 0 0 7.5Zm7-3.5 2-1-2-3-2 .5-1-2 .5-2-3-2-1 2-3-.5-2 3 2 1v2l-2 1 2 3 2-.5 1 2-.5 2 3 2 1-2 3 .5 2-3-2-1v-2Z',
  warning: 'M12 3 2 21h20L12 3Zm0 6v5m0 3v.01',
};

@Component({
  selector: 'ds-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'ds-icon', '[attr.aria-hidden]': "label() ? null : 'true'" },
  template: `
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
    >
      <path [attr.d]="path()" />
    </svg>
    @if (label()) {
      <span class="ds-visually-hidden">{{ label() }}</span>
    }
  `,
})
export class DsIconComponent {
  readonly name = input.required<DsIconName>();
  readonly label = input('');
  protected readonly path = computed(() => paths[this.name()]);
}
